// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const pinReportPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  report_id: z.number().int().describe("Report ID to pin"),
});

export const pinReportHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Report pinned successfully
 */
export const pinReport201Schema = z.object({});

/**
 * @description Report not found
 */
export const pinReport404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const pinReportMutationResponseSchema = z.lazy(() => pinReport201Schema);
